import axios from 'axios';
import {
  EMPLOYEE_UPLOAD_REQUEST,
  EMPLOYEE_UPLOAD_SUCCESS,
  EMPLOYEE_UPLOAD_FAIL,
  EMPLOYEE_LIST_REQUEST,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_FAIL,
  EMPLOYEE_CREATE_REQUEST,
  EMPLOYEE_CREATE_SUCCESS,
  EMPLOYEE_CREATE_FAIL,
  EMPLOYEE_UPDATE_REQUEST,
  EMPLOYEE_UPDATE_SUCCESS,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_DELETE_REQUEST,
  EMPLOYEE_DELETE_SUCCESS,
  EMPLOYEE_DELETE_FAIL,
  EMPLOYEE_MARK_LEFT_REQUEST,
  EMPLOYEE_MARK_LEFT_SUCCESS,
  EMPLOYEE_MARK_LEFT_FAIL,
  EMPLOYEE_REJOIN_REQUEST,
  EMPLOYEE_REJOIN_SUCCESS,
  EMPLOYEE_REJOIN_FAIL,
} from '../constants/employeeMasterConstants';

const baseUrl = process.env.REACT_APP_API_URL;

const getAuthConfig = (userInfo, isMultipart = false) => ({
  headers: {
    Authorization: `Bearer ${userInfo.token}`,
    ...(isMultipart ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' }),
  },
});

export const uploadEmployeeExcel = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_UPLOAD_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${baseUrl}/employees/upload`, formData, getAuthConfig(userInfo, true));
    dispatch({ type: EMPLOYEE_UPLOAD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EMPLOYEE_UPLOAD_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const listEmployees = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_LIST_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { company, type, isLeft, search, page, limit } = params;
    const query = new URLSearchParams();
    if (company) query.append('company', company);
    if (type) query.append('type', type);
    if (isLeft !== undefined) query.append('isLeft', isLeft);
    if (search) query.append('search', search);
    if (page) query.append('page', page);
    if (limit) query.append('limit', limit);
    const { data } = await axios.get(`${baseUrl}/employees?${query.toString()}`, getAuthConfig(userInfo));
    dispatch({ type: EMPLOYEE_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EMPLOYEE_LIST_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const createEmployee = (employeeData) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_CREATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${baseUrl}/employees`, employeeData, getAuthConfig(userInfo));
    dispatch({ type: EMPLOYEE_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EMPLOYEE_CREATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const updateEmployee = (id, employeeData) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${baseUrl}/employees/${id}`, employeeData, getAuthConfig(userInfo));
    dispatch({ type: EMPLOYEE_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EMPLOYEE_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const deleteEmployee = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_DELETE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    await axios.delete(`${baseUrl}/employees/${id}`, getAuthConfig(userInfo));
    dispatch({ type: EMPLOYEE_DELETE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: EMPLOYEE_DELETE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const markEmployeeLeft = (id, leftDate) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_MARK_LEFT_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${baseUrl}/employees/${id}/mark-left`, { leftDate }, getAuthConfig(userInfo));
    dispatch({ type: EMPLOYEE_MARK_LEFT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EMPLOYEE_MARK_LEFT_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const rejoinEmployee = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_REJOIN_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${baseUrl}/employees/${id}/rejoin`, {}, getAuthConfig(userInfo));
    dispatch({ type: EMPLOYEE_REJOIN_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EMPLOYEE_REJOIN_FAIL, payload: error.response?.data?.message || error.message });
  }
};
